import React from 'react';
import config from 'react-global-configuration';

import NodeBasicPageFull from './Full';
import GenericBasicPage from './Generic';
import NodeBasicPageCampaign from './Campaign';
import { SimpleTeaser } from '../../../components';
import NodeBasicPageFullWithSidebar from './FullWithSidebar';
import PopupNode from '../../../components/PopupAnnouncement/PopupNode';
import { AWARDS_PAGE_NODE_ID, MAATJES_DOMAIN } from '../../../config/constants';

const NodeBasicPage = ({ variant, viewMode, entity, ...props }) => {
  if (viewMode === 'teaser') {
    return <SimpleTeaser withSummary entity={entity} {...props} />;
  }

  if (viewMode === 'popup') {
    return <PopupNode entity={entity} {...props} />;
  }

  // TODO: Get this from Drupal Context.
  if (entity.getIn(['nid', 0, 'value']) === AWARDS_PAGE_NODE_ID) {
    return <NodeBasicPageFullWithSidebar entity={entity} {...props} />;
  }

  if (config.get('CURRENT_DOMAIN') === MAATJES_DOMAIN) {
    return <GenericBasicPage entity={entity} {...props} />;
  }

  switch (variant) {
    case 'campaign':
      return <NodeBasicPageCampaign entity={entity} {...props} />;
    case 'privacy':
      return <NodeBasicPageCampaign entity={entity} {...props} />;
    default:
      return <NodeBasicPageFull entity={entity} {...props} />;
  }

};

export default NodeBasicPage;
